// extracted by mini-css-extract-plugin
export var backButton = "BackButton-module--backButton--322a0";
export var backButtonWrapper = "BackButton-module--backButtonWrapper--7f5a2";